interface ICache {
  pathname?: string
  key?: string
  value?: string | number
}

const cacheKey = 'globalCache'

export const getGlobalCache = (props?: ICache) => {
  const { pathname = location.pathname, key } = props || {}
  const globalCache = JSON.parse(localStorage.getItem(cacheKey) || '{}')
  if (key) return globalCache[pathname]?.[key]
  if (props && !key) return globalCache[pathname] || {}
  if (!props) return globalCache
  return null
}

export const setGlobalCache = (props?: ICache) => {
  const { pathname, key, value } = props || {}
  const pathName = pathname || location.pathname
  const globalCache = getGlobalCache()

  if (!globalCache[pathName]) globalCache[pathName] = {}
  globalCache[pathName][key] = value
  localStorage.setItem(cacheKey, JSON.stringify(globalCache))
}
